import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import BusinessUnitContext from '../../contexts/BusinessUnitAccessContext';
import PrivilegesContext from '../../contexts/PrivilegesContext';
import { useQIRReport } from '../../hooks/useQIRs';
import DateRange from '../DateRange';
import QIRsTable from './QIRsTable';

function QIRsList({ user, closed, tableName }) {

    const { t } = useTranslation();
    const { assignedBusinessUnits } = useContext(BusinessUnitContext);
    const { contributor } = useContext(PrivilegesContext);
    const { getQIRReport, loading: loadingQIRReport } = useQIRReport();
    const [csvData, setCSVData] = useState();

    const [businessUnitNames, setBusinessUnitNames] = useState();

    const getFromDate = () => {
        // Today
        let fromDate = new Date();

        // Last day of the previous month
        fromDate.setDate(0);
        // First day of previous month after setting the date to the last day of the previous month
        fromDate.setDate(1);

        fromDate.setMonth(fromDate.getMonth() - 2);

        return fromDate.toISOString().split('T')[0];
    }

    const defaultDateRange = {
        from: getFromDate()
    };

    const [dateFilter, setDateFilter] = useState(defaultDateRange);

    const getDateString = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}${month}${day}`
    }

    useEffect(() => {
        if (assignedBusinessUnits) {
            setBusinessUnitNames(assignedBusinessUnits.map(bu => bu.name))
        }
    }, [assignedBusinessUnits])

    if (businessUnitNames === undefined) {
        return (
            <div className="d-flex justify-content-center">
                <p className="text-muted">{t('Authorization.GettingPrivilegesMessage')}</p>
            </div>
        );
    }

    if (businessUnitNames.length === 0) {
        return (
            <h4 className="d-flex justify-content-center">{t("QIRList.NoRecords")}</h4>
        );
    }

    return (
        <Container className="mb-5">
            <Row>
                <Col>
                    <DateRange dateFilter={dateFilter} setDateFilter={setDateFilter} />
                </Col>
                <Col>
                    {contributor &&
                        <div className="d-flex justify-content-end mb-3">
                            <Link to="/qir/create" className="btn btn-primary me-2">
                                {t('QIRList.CreateQIR')}
                            </Link>

                            <Button onClick={() => getQIRReport(businessUnitNames)} className="me-2">
                                {t('QIRList.DailyReport')}
                                {loadingQIRReport &&
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="ms-2"
                                    />
                                }
                            </Button>

                            {csvData &&
                                <CSVLink className="btn btn-primary" style={{ textDecoration: 'none' }} filename={`QIR-Export-${getDateString()}.csv`} data={csvData} >
                                    {t('QIRList.ExportData')}
                                </CSVLink>
                            }
                        </div>
                    }
                </Col>
            </Row>

            {businessUnitNames && dateFilter &&
                <Row>
                    <QIRsTable tableName={tableName} businessUnits={businessUnitNames} dateFrom={dateFilter.from} dateTo={dateFilter.to} user={user} closed={closed} setCSVData={setCSVData} />
                </Row>
            }
        </Container>
    )
}

export default QIRsList;